var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_Facebook"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "bg",
    cx: 24.4287,
    cy: 24.3633,
    rx: 20.9999,
    ry: 21,
    fill: "url(#paint0_linear_1450_13027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M32.2512 31.4067L33.184 25.4795H27.3485V21.6349C27.3485 20.0129 28.1621 18.431 30.7759 18.431H33.4306V13.3849C33.4306 13.3849 31.0224 12.9844 28.721 12.9844C23.9129 12.9844 20.7731 15.8238 20.7731 20.962V25.4795H15.4307V31.4067H20.7731V45.7361C21.8457 45.9003 22.943 45.9844 24.0608 45.9844C25.1786 45.9844 26.2759 45.9003 27.3485 45.7361V31.4067H32.2512Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1450_13027",
    x1: 24.4287,
    y1: 3.36328,
    x2: 24.4287,
    y2: 45.2387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0163E0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon_Facebook.e969cba299db4fe48af345199bcdf912.svg";
export { ForwardRef as ReactComponent };